import React, { Component } from 'react';
import HedingText from '../../../shared/components/form/HeadingText';
import { Button, Container } from 'reactstrap';
import Error from '../../../shared/components/form/Error';
import config from '../../../config/app.config';
import FacilityPopup from '../../facility/UpdateFacility';

const SUPER_ADMIN = config.USER_TYPES.SUPER_ADMIN;
const ADMIN = config.USER_TYPES.ADMIN;
const STAFF = config.USER_TYPES.STAFF;

export default class ProfileDetailsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userType: null,
      privateCredentials: true,
      errorFirstName: null,
      errorLastName: null,
      changed: false,
      showFacilityPopup: false,
    };
  }

  onChangeFields = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      changed: true,
    });
  };

  onSubmit = () => {
    const { changed } = this.state;
    if (!this.validate() && changed) {
      this.props.update(this.state);
      this.setState({ changed: false });
    }
  };

  validate = () => {
    const { firstName, lastName } = this.state;
    let errorFirstName = null;
    let errorLastName = null;
    let error = false;

    if (!firstName) {
      errorFirstName = 'First name cannot be empty';
      error = true;
    } else if (/\s/.test(firstName)) {
      errorFirstName = 'Invalid first name';
      error = true;
    }

    if (!lastName) {
      errorLastName = 'Last name cannot be empty';
      error = true;
    } else if (/\s/.test(lastName)) {
      errorLastName = 'Invalid last name';
      error = true;
    }

    this.setState({ errorFirstName, errorLastName });
    return error;
  };

  UNSAFE_componentWillReceiveProps(np) {
    if (np.profile) {
      const {
        firstName,
        lastName,
        email,
        type: userType,
        facility,
        designation,
        username,
        privateCredentials,
        _id,
      } = np.profile;

      this.setState({
        firstName,
        lastName,
        email,
        userType,
        facility,
        designation,
        username,
        privateCredentials: !(
          privateCredentials === false || privateCredentials === 'false'
        ),
        _id,
      });
    }
  }

  showFacility = () => {
    this.setState({ showFacilityPopup: true });
  };

  closeFacilityPopup = () => {
    this.setState({ showFacilityPopup: false });
  };

  render() {
    const {
      userType,
      privateCredentials,
      showFacilityPopup,
      firstName,
      lastName,
      email,
      facility,
      designation,
      username,
      errorFirstName,
      errorLastName,
    } = this.state;

    const isAssigned = privateCredentials === false;
    const facilityName = facility && facility.name;
    const facilityId = facility && facility._id;
    const designationName = designation && designation.name;
    const canEditNames = !isAssigned && userType !== STAFF;
    const showUpdate =
      !isAssigned && (userType === ADMIN || userType === SUPER_ADMIN);
    const roleLabel =
      userType === SUPER_ADMIN
        ? 'Super Admin'
        : userType === STAFF
          ? designationName || 'User'
          : 'Admin';

    return (
      <div
        className={
          isAssigned
            ? 'profile-details profile-details--assigned'
            : 'profile-details profile-details--private'
        }
      >
        <Container>
          <HedingText text="Basic Information" />
          <form className="form">
            {isAssigned ? (
              <>
                <div className="profile-field-row">
                  <div className="form__form-group profile-field profile-field--name">
                    <span className="form__form-group-label">Username</span>
                    <div className="form__form-group-field">
                      <input
                        name="username"
                        type="text"
                        placeholder=""
                        value={username || ''}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form__form-group profile-field profile-field--name">
                    <span className="form__form-group-label">
                      {userType === STAFF && designationName ? 'Designation' : 'Role'}
                    </span>
                    <div className="form__form-group-field">
                      <input
                        name="designation"
                        type="text"
                        placeholder=""
                        value={roleLabel}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="profile-field-row">
                  <div className="form__form-group profile-field profile-field--name">
                    <span className="form__form-group-label">First Name</span>
                    <div className="form__form-group-field">
                      <input
                        name="firstName"
                        type="text"
                        placeholder=""
                        value={firstName || ''}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form__form-group profile-field profile-field--name">
                    <span className="form__form-group-label">Last Name</span>
                    <div className="form__form-group-field">
                      <input
                        name="lastName"
                        type="text"
                        placeholder=""
                        value={lastName || ''}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="profile-field-row">
                  <div className="form__form-group profile-field profile-field--name">
                    <span className="form__form-group-label">
                      First Name
                      {canEditNames && (
                        <span className="loyal-required-star">*</span>
                      )}
                    </span>
                    <div className="form__form-group-field">
                      <input
                        name="firstName"
                        type="text"
                        placeholder="First Name"
                        value={firstName || ''}
                        onChange={this.onChangeFields}
                        maxLength={50}
                        disabled={!canEditNames}
                      />
                    </div>
                    {errorFirstName && <Error text={errorFirstName} />}
                  </div>
                  <div className="form__form-group profile-field profile-field--name">
                    <span className="form__form-group-label">
                      Last Name
                      {canEditNames && (
                        <span className="loyal-required-star">*</span>
                      )}
                    </span>
                    <div className="form__form-group-field">
                      <input
                        name="lastName"
                        type="text"
                        placeholder="Last Name"
                        value={lastName || ''}
                        onChange={this.onChangeFields}
                        maxLength={50}
                        disabled={!canEditNames}
                      />
                    </div>
                    {errorLastName && <Error text={errorLastName} />}
                  </div>
                </div>

                <div className="profile-field-row">
                  {facilityName && (
                    <div className="form__form-group profile-field profile-field--wide">
                      <span className="form__form-group-label">Facility</span>
                      <div className="form__form-group-field">
                        <input
                          name="facility"
                          type="text"
                          placeholder=""
                          value={facilityName}
                          disabled
                        />
                      </div>
                    </div>
                  )}
                  <div className="form__form-group profile-field profile-field--wide">
                    <span className="form__form-group-label">
                      Email<span className="loyal-required-star">*</span>
                    </span>
                    <div className="form__form-group-field">
                      <input
                        name="email"
                        type="text"
                        placeholder=""
                        value={email || ''}
                        disabled
                      />
                    </div>
                  </div>
                </div>

                {showUpdate && (
                  <div className="profile-field-row profile-field-row--actions">
                    <Button onClick={this.onSubmit} color="primary">
                      Update
                    </Button>
                  </div>
                )}
              </>
            )}
          </form>
        </Container>

        {showFacilityPopup && (
          <FacilityPopup
            view={true}
            fromProfile={true}
            closeFacilityPopup={this.closeFacilityPopup}
            selectedId={facilityId}
          />
        )}
      </div>
    );
  }
}
